import {
    FETCHING_EXTERNAL_LIBRARY,
    FETCHING_EXTERNAL_LIBRARY_SUCCEDED,
    FETCHING_EXTERNAL_LIBRARY_FAILED,
    RESET_EXTERNAL_LIBRARY
} from "../actions/actionTypes.jsx";


const initialState = {
    currentPage: 0,
    totalPages: 0,
    totalRecordsCount: 0,
    fetching: false,
    records: []
};

function externalLibraryReducer(state = initialState, action) {
    switch (action.type) {
        case FETCHING_EXTERNAL_LIBRARY:
            return Object.assign({}, state, {
                ...state,
                fetching: true
            })

        case FETCHING_EXTERNAL_LIBRARY_SUCCEDED:

            var records = [];

            if (action.payload.currentPage == 0) {
                records = action.payload.images.records;
            } else {
                records = [...state.records, ...action.payload.records];
            }


            return Object.assign({}, state, {
                ...state,
                fetching: false,
                records: records,
                currentPage: action.payload.currentPage,
                totalPages: action.payload.totalPages,
                totalRecordsCount: action.payload.totalRecordsCount,
            })

        case FETCHING_EXTERNAL_LIBRARY_FAILED:

            return Object.assign({}, state, {
                ...state,
                fetching: false,
                error: action.payload
            })

        case RESET_EXTERNAL_LIBRARY:

            return initialState

        default:
            return state;
    }
}

export { externalLibraryReducer };